export function transformString(input: string): string {
    return input
      .replace(/\s*\/\s*/g, "_") // Replace `/` and any spaces around it with `_`
      .replace(/\s+/g, "_"); // Replace remaining spaces with `_`
  }
  
  export function reverseTransformString(input: string): string {
    return input
      .replace(/_/g, ' ') // Replace underscores with spaces
      .replace(/([A-Z])/g, ' $1') // Add spaces before uppercase letters
      .toLowerCase() // Convert all letters to lowercase
      .trim(); // Remove any leading or trailing spaces
  }